module.exports = __webpack_public_path__ + "ef78eec4aad149ca4d205488eaa4eb7e.jpg";